import React from 'react';

/** Formata telefone BR: (00)0000-0000 ou (00)00000-0000 */
export function formatTelefone(value) {
  const d = String(value || '').replace(/\D/g, '').slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)})${d.slice(2)}`;
  if (d.length <= 10) {
    return `(${d.slice(0, 2)})${d.slice(2, 6)}-${d.slice(6)}`;
  }
  return `(${d.slice(0, 2)})${d.slice(2, 7)}-${d.slice(7)}`;
}

const inputStyle = {
  width: '100%',
  maxWidth: '100%',
  minWidth: '0',
  height: '40px',
  padding: '8px 12px',
  margin: 0,
  borderRadius: '4px',
  border: '1px solid #ccc',
  background: '#fff',
  boxSizing: 'border-box',
  display: 'block',
  fontSize: '1rem',
  fontFamily: 'inherit',
};

export default function InputTelefoneCustom({ value, onChange, disabled, placeholder, id, ...props }) {
  return (
    <input
      id={id}
      type="text"
      inputMode="tel"
      autoComplete="tel"
      placeholder={placeholder || '(00)00000-0000'}
      value={formatTelefone(value)}
      onChange={(e) => {
        const formatted = formatTelefone(e.target.value);
        onChange && onChange(formatted);
      }}
      disabled={disabled}
      style={inputStyle}
      {...props}
    />
  );
}
